import React from 'react'

import logo from "../../resource/7.png";
import imageOne from "../../resource/meditate/internalRetreats/timeTabel/1.png";

import imageThree from "../../resource/meditate/internalRetreats/timeTabel/2.png";





const TimeTable = () => {
  return (
    <div className='internalRetreat-page inside-pages'>
        <div className="right-box">
      <img
        src={imageOne}
        alt="Right Top Image"
        className="right-image"
        width={300}
      />
    </div>
        
         <div className="text-center">
         <img src={logo} alt="" width={200} />
          <div className="details mt-4">
            <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
            <h2 className="h4">Retreat Time Table</h2>
        
         </div>
        </div>


        <div className="table mt-6 dark-gold font-p">
        <div className="row header-row dark-gold text-bold">
          <div className="cell time font-second">Time</div>
          <div className="cell activity font-second">Activity</div>
        </div>
        <div className="row">
          <div className="cell time">04:30 am</div>
          <div className="cell activity">Wake Up</div>
        </div>
        <div className="row">
          <div className="cell time">05:00 am - 06:00 am</div>
          <div className="cell activity">Sitting Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">06:00 am - 07:00 am</div>
          <div className="cell activity">Walking Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">07:00 am - 08:00 am</div>
          <div className="cell activity">Breakfast and Cleaning Duties</div>
        </div>
        <div className="row">
          <div className="cell time">08:30 am - 09:30 am</div>
          <div className="cell activity">Dhamma Sermon</div>
        </div>
        <div className="row">
          <div className="cell time">09:30 am - 10:30 am</div>
          <div className="cell activity">Walking Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">10:30 am - 11:15 am</div>
          <div className="cell activity">Sitting Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">11:15 am - 12:00 pm</div>
          <div className="cell activity">Lunch</div>
        </div>
        <div className="row">
          <div className="cell time">12:00 pm - 01:00 pm</div>
          <div className="cell activity">Resting Time</div>
        </div>
        <div className="row">
          <div className="cell time">01:00 pm - 02:30 pm</div>
          <div className="cell activity">Dhamma Discussion</div>
        </div>
        <div className="row">
          <div className="cell time">02:30 pm - 03:30 pm</div>
          <div className="cell activity">Walking Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">03:30 pm - 04:30 pm</div>
          <div className="cell activity">Sitting Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">04:30 pm - 05:00 pm</div>
          <div className="cell activity">Tea Time</div>
        </div>
        <div className="row">
          <div className="cell time">05:00 pm - 06:00 pm</div>
          <div className="cell activity">Walking Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">06:00 pm - 07:00 pm</div>
          <div className="cell activity">Sitting Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">07:00 pm - 08:00 pm</div>
          <div className="cell activity">Walking Meditation</div>
        </div>
        <div className="row">
          <div className="cell time">08:00 pm - 09:30 pm</div>
          <div className="cell activity">Dhamma Sermon</div>
        </div>
        <div className="row">
          <div className="cell time">09:30 pm</div>
          <div className="cell activity">Rest</div>
        </div>
      </div>


      <div className="bottom-box mt-6">
      <img src={imageThree} alt="bottom-image" width={400} />
    </div>
    </div>
  )
}

export default TimeTable